(() => {
  const init = root => {
    root.querySelectorAll('[data-rw-menu]').forEach(button => {
      if(button.dataset.ready)return;button.dataset.ready='1';
      button.addEventListener('click',()=>{const nav=document.getElementById(button.getAttribute('aria-controls'));const open=nav.classList.toggle('rw-open');button.setAttribute('aria-expanded',String(open));});
    });
    root.querySelectorAll('[data-rw-products]').forEach(section=>{
      if(section.dataset.ready)return;section.dataset.ready='1';
      section.querySelectorAll('[data-rw-filter]').forEach(button=>button.addEventListener('click',()=>{
        section.querySelectorAll('[data-rw-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        section.querySelectorAll('[data-rw-product-holder]').forEach(el=>{el.hidden=button.dataset.rwFilter!=='Alle'&&el.querySelector('[data-rw-group]')?.dataset.rwGroup!==button.dataset.rwFilter;});
      }));
    });
    root.querySelectorAll('[data-rw-sort]').forEach(s=>{if(s.dataset.ready)return;s.dataset.ready='1';s.addEventListener('change',()=>s.form.requestSubmit());});
    root.querySelectorAll('[data-rw-product]').forEach(section=>{
      if(section.dataset.ready)return;section.dataset.ready='1';
      const image=section.querySelector('#rw-main-photo');
      section.querySelectorAll('[data-rw-photo]').forEach(b=>b.addEventListener('click',()=>{image.removeAttribute('srcset');image.src=b.dataset.rwPhoto;image.alt=b.dataset.rwAlt||'';section.querySelectorAll('[data-rw-photo]').forEach(t=>t.setAttribute('aria-pressed',String(t===b)));}));
      const select=section.querySelector('[data-rw-variant]');
      if(select)select.addEventListener('change',()=>{
        const variants=JSON.parse(section.querySelector('[data-rw-variants]').textContent),labels=JSON.parse(section.querySelector('[data-rw-labels]').textContent),v=variants.find(v=>String(v.id)===select.value);
        if(!v)return;
        section.querySelector('.rw-detail-price').textContent=v.price;
        const button=section.querySelector('[data-rw-add]');button.disabled=!v.available;button.textContent=v.available?labels.add:labels.sold;
        if(v.image){image.removeAttribute('srcset');image.src=v.image;}
        const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u);
      });
    });
  };
  document.addEventListener('DOMContentLoaded',()=>{
    init(document);
    if(location.pathname.endsWith('/policies/terms-of-service')){
      const target=[...document.querySelectorAll('p,h2,h3')].find(el=>/^7\)\s*Mängelhaftung\s*\(Gewährleistung\)/.test(el.textContent.trim()));
      if(target){target.id='gewaehrleistung';target.style.scrollMarginTop='24px';if(location.hash==='#gewaehrleistung')requestAnimationFrame(()=>target.scrollIntoView({block:'start'}));}
    }
  });
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){document.querySelectorAll('.rw-nav').forEach(n=>n.classList.remove('rw-open'));document.querySelectorAll('[data-rw-menu]').forEach(b=>b.setAttribute('aria-expanded','false'));}});
})();
